// NOTE: redundant with src/domain/conversation/functions/getAllConversationId.ts
// remember to update all implementations
export const getAllConversationId = (chatUnitId: string) => {
  return `all-${chatUnitId}`;
};
